import { useGetCompanyQuery } from '../../../lendingApi/lendingApiQueries';
import RouteSpinner from '../../RouteSpinner/RouteSpinner';
import GetStartedUK from '../GetStartedUK/GetStartedUK';

type TProps = {
  handleStateUpdateError: (error: Error) => void;
};

const GetStartedWithPrefillUK = ({ handleStateUpdateError }: TProps) => {
  const { company, isLoadingCompany } = useGetCompanyQuery();

  if (isLoadingCompany) {
    return <RouteSpinner />;
  }

  return (
    <GetStartedUK
      company={company}
      handleStateUpdateError={handleStateUpdateError}
    />
  );
};

export default GetStartedWithPrefillUK;
